import React, { useState } from "react";
import HomeThreeSingleFaq from "../../../components/HomeThreeSingleFaq/HomeThreeSingleFaq";

const HomeThreeFaq = () => {
  const [openFaqIndex, setOpenFaqIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenFaqIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const faqData = [
    {
      number: "One",
      condition: true,
      secondClassAdd: "show",
      question: "O que significa ser uma mulher Olis?",
      answer: `
        <p><strong>Olis</strong> são mulheres autoconfiantes, fortes, que não têm medo de viver. Sua personalidade dinâmica mostra que uma mulher pode ser muitas coisas - poderosa, motivada, vulnerável e sensível - e que as emoções devem ser sentidas e expressas. <strong>Olis</strong> são mulheres fortes, que vivem seu poder de escolha. Umas querem ter filhos, outras não, e outras optaram por postergar a maternidade. Sozinhas ou acompanhadas, <strong>Olis</strong> vivem intensamente na busca por seus sonhos.</p>
      `,
    },
    {
      number: "Two",
      fistClassAdd: "collapsed",
      question: "O que é a plataforma Olis e como ela pode me ajudar?",
      answer: `
        <p>A <strong>Olis</strong> é uma plataforma dedicada à mulher moderna que precisa de praticidade no seu dia a dia, oferecendo saúde de forma <strong>objetiva</strong>, <strong>personalizada</strong> e <strong>descomplicada</strong>.</p>
        <p>Por meio da <strong>telemedicina</strong>, conectamos profissionais e pacientes na jornada por saúde, bem-estar e qualidade de vida. Com um olhar personalizado, a <strong>Olis</strong> oferece serviços diversos, na comodidade da sua casa, sem necessidade de:</p>
          filas de espera, deslocamentos, perda excessiva do seu valioso tempo.`,
    },
    {
      number: "Three",
      fistClassAdd: "collapsed",
      question: "Como agendar uma consulta na plataforma Olis?",
      answer: `
        <p>Agendar uma consulta na <strong>Olis</strong> é simples e rápido:</p>
        <ul>
          <li>- Escolha o serviço desejado</li>
          <li>- Selecione um horário conveniente</li>
          <li>- Preencha o formulário com suas informações</li>
          <li>- Realize o pagamento</li>
          <li>- Receba o link para a consulta por videochamada.</li>
        </ul>
      `,
    },
    {
      number: "Four",
      fistClassAdd: "collapsed",
      question: "Que tipo de serviços a Olis oferece?",
      answer: `
        <p>A <strong>Olis</strong> oferece uma ampla variedade de serviços de saúde para mulheres, incluindo:</p>
        <ol>
          <li>Consultas ginecológicas de rotina,</li>
          <li>Primeira consulta ginecológica para adolescentes,</li>
          <li>Escolha do método contraceptivo,</li>
          <li>Avaliação de fertilidade,</li>
          <li>Investigação da infertilidade,</li>
          <li>Reposição hormonal.</li>
          <li>Consultoria pré-natal,</li>
          <li>Suplementação gestacional e pós-parto,</li>
          <li>Suporte para diabetes gestacional.</li>
        </ol>
        <p>Todos os serviços são realizados por profissionais de saúde <strong>especialistas</strong> e <strong>humanizados</strong>.</p>
      `,
    },
    {
      number: "Five",
      fistClassAdd: "collapsed",
      question: "Uma consulta online é segura e eficaz?",
      answer: `
        <p><strong>Sim</strong>, nossas consultas online são seguras e eficazes.</p>
        <p>Utilizamos plataformas de videochamada seguras para garantir a <strong>privacidade</strong> e a <strong>confidencialidade</strong> de todas as informações.</p>
        <p>Nossos profissionais de saúde são treinados para oferecer atendimento de <strong>alta qualidade</strong> de forma remota, garantindo que você receba o cuidado necessário sem precisar sair de casa.</p>
      `,
    },
    {
      number: "Six",
      fistClassAdd: "collapsed",
      question: "Como devo me preparar para a consulta online?",
      answer: `
        <p>Para se preparar para a consulta online, siga estas orientações:</p>
        <ol>
          <li>Escolha um local tranquilo, privado e bem iluminado para a consulta,</li>
          <li>Certifique-se de que haja boa conexão à internet para evitar interrupções,</li>
          <li>Utilize um dispositivo (computador, tablet ou smartphone) com câmera e microfone funcionais,</li>
          <li>Faça um teste antes da consulta para garantir que tudo esteja operando corretamente,</li>
          <li>Tenha à mão seu histórico médico atualizado,</li>
          <li>Envie antecipadamente seus exames prévios, se houverem, para avaliação no nosso e-mail <strong>contato@mulherolis.com</strong>.</li>
        </ol>
      `,
    },
    {
      number: "Seven",
      fistClassAdd: "collapsed",
      question: "Como pode ser feito o pagamento da sua consulta?",
      answer: `
        <p>Aceitamos pagamento por <strong>PIX</strong> à vista e parcelamos em até <strong>6x no cartão de crédito</strong>.</p>
        <p>Nossos serviços podem ser reembolsados, caso você tenha plano de saúde (consulte condições com o seu convênio médico).</p>
      `,
    },
    {
      number: "Eight",
      fistClassAdd: "collapsed",
      question: "Como funciona o suporte pós-consulta?",
      answer: `
        <p>Após a consulta, você receberá todas as recomendações , prescrições e relatório de consulta em seu whatsapp . 
Os exames realizados poderão ser anexados via link que você receberá após a consulta no whatsapp . 
A consulta de retorno será agendada por você , conforme sua disponibilidade, via link enviado para o seu whatsapp . 
Qualquer dúvida , estaremos à disposição pelo whatsapp ou via e-mail contato@mulherolis.com .</p>
      `,
    },
    {
      number: "Nine",
      fistClassAdd: "collapsed",
      question: "Política de Cancelamento, Reagendamento e Atendimento",
      answer: `
        <p><strong>Política de Cancelamento, Reagendamento e Atendimento OLIS | Telemedicina</strong></p>
        
        <h4>1. Cancelamento de Consultas:</h4>
        <p><strong>a.</strong> O cancelamento da consulta poderá ser realizado sem cobrança até 24 horas antes do horário agendado.</p>
        <p>Para cancelar a sua consulta online você deverá utilizar a plataforma online na qual você reservou a consulta, ou (caso aplicável) o formulário ou link enviado pelo profissional.</p>
        <p>Os valores pagos por você pela consulta online serão reembolsadas pelo profissional no prazo máximo de 14 (quatorze) dias a partir do recebimento do seu pedido de cancelamento e usando o mesmo método de pagamento usado por você para pagar as taxas (salvo acordo contrário), sendo que, os cancelamentos, ausências e atrasos superiores ao tempo de tolerância descrito abaixo, sujeitam-se a retenção de taxa administrativa de 4.95% sobre o valor da consulta, para a cobertura dos custos de processamento de pagamento.</p>
        
        <p><strong>b.</strong> Cancelamentos fora deste prazo, ou o não comparecimento à consulta, implicarão na cobrança integral do valor pago, sem possibilidade de reembolso.</p>
        
        <h4>2. Reagendamento de Consultas:</h4>
        <p><strong>a.</strong> O reagendamento poderá ser feito uma vez, com até 12 horas de antecedência do horário agendado, sem custo adicional.</p>
        <p><strong>b.</strong> A solicitação de reagendamento deverá ser feita exclusivamente através do contato da Olis: <strong>11958799090</strong> (WhatsApp).</p>
        <p><strong>c.</strong> O novo horário deverá ser escolhido de acordo com a disponibilidade de horários da plataforma.</p>
        <p><strong>d.</strong> Reagendamentos solicitados fora deste prazo não serão permitidos, sendo considerado falta na consulta, sem direito a reembolso.</p>
        
        <h4>3. Tolerância para Atrasos:</h4>
        <p><strong>a.</strong> A paciente tem até 15 minutos de tolerância após o início agendado da consulta para acessar o link da teleconsulta.</p>
        <p><strong>b.</strong> Após esse período, a consulta será considerada perdida (no-show), sendo registrada e cobrada normalmente, sem reembolso.</p>
        
        <h4>4. Definição de Não Comparecimento (No-show):</h4>
        <p><strong>a.</strong> Considera-se no-show quando a paciente não comparece ou não acessa o link da teleconsulta no tempo previsto, sem aviso prévio.</p>
        <p><strong>b.</strong> O no-show não será reembolsado e ocupará o horário de atendimento previsto.</p>
        
        <h4>5. Plataforma e Acesso:</h4>
        <p>A consulta será realizada de forma online, por videochamada, em plataforma segura, com link enviado previamente via e-mail ou WhatsApp.</p>
        
        <h4>6. Responsabilidades da Paciente:</h4>
        <ul>
          <li>Garantir o acesso à plataforma no horário marcado.</li>
          <li>É responsabilidade do paciente verificar previamente sua conexão de internet, áudio e câmera, bem como entrar no link no horário combinado.</li>
          <li>Comunicar com antecedência em caso de imprevistos (conforme os horários acima especificados).</li>
          <li>Estar em local reservado, com boa conexão, para preservar o sigilo da consulta.</li>
          <li>Concordar com os termos de atendimento online da OLIS.</li>
        </ul>
        
        <h4>7. Contato e Suporte:</h4>
        <p>Em caso de problemas técnicos ou dúvidas sobre este termo, o contato deverá ser feito pelo WhatsApp: <strong>11958799090</strong>.</p>
      `,
    },
  ];

  return (
    <>
      <div
        className="section-faq-area pt-120 pb-100"
        style={{ background: "#d5c5e6" }}
      >
        <div className="container">
          <div className="row" style={{ justifyContent: "center" }}>
            <div className="col-xl-8 col-lg-12">
              <div className="about-title mb-45">
                <h5 className="pink-color">Perguntas Frequentes</h5>
                <h1>Tudo o que você precisa saber</h1>
              </div>
              <div className="faq-right-box">
                <div id="accordion" className="mt-40">
                  {faqData.map((faq, index) => (
                    <HomeThreeSingleFaq
                      key={index}
                      number={faq.number}
                      isOpen={openFaqIndex === index}
                      onClick={() => handleToggle(index)}
                      question={faq.question}
                      answer={faq.answer}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeThreeFaq;
